// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"8c86507d","343":"d139e7d7","517":"b26b59ee"}[chunkId] + ".chunk.js";
};